module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_05@2x-0b46f21358d57114ac8e069b1b844c03.jpg";